export default __webpack_public_path__ + "static/media/filterIconWhite.959c7a72.svg";